import './course-information.scss';
import './course-information.html.twig';
